import { Select } from "baseui/select";
import { IAutomationObject } from "../../automationObjects";
import { useGetObjectClassByNameQuery } from "../../services/objects";
import { useState } from "react";

const ignoreProperties = ["$dtId","$metadata","customTags","id","resourceGroupId","ModelId","schema", "externalIds"]

const AppPropertySelector = (props: { app: IAutomationObject, onSelectionChanged(propertyName: string | undefined) }) => {
    const { data, isLoading, isSuccess } = useGetObjectClassByNameQuery(props.app.schema);

    const [selected, setSelected] = useState();
    const options = data?.properties.filter((item: any) => !ignoreProperties.includes(item.name)).map((item: any) => {return { label: item.name, id: item.name }})

    const onPropertyChanged = (e: any) => {
        setSelected(e.value)
        if ( e.option )
            props.onSelectionChanged(e.option.id);
        else
            props.onSelectionChanged(undefined);
    };
    return (<>
        <Select
            options={options}
            value={selected}
            required
            placeholder="Select property"
            onChange={onPropertyChanged}
        />
    </>)
}

export default AppPropertySelector;